import { useCallback, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  AssignmentRuleDTO,
  bulkEnableDisable,
  reorderAssignmentRules,
  setAssignmentRulesOrder,
} from '@user/store/leadAssignmentRule'
import { DropResult } from '@user/utils/Draggable'
import { toast } from '@sales-center/components'
import { parseCoverageError } from '../../../utils/coverageError'

type Props = {
  setAssignmentRulesReOrderTemp: (
    value: React.SetStateAction<AssignmentRuleDTO[]>,
  ) => void
  assignmentRulesReOrderTemp: AssignmentRuleDTO[]
}

export function useHandlers(props: Props) {
  const { assignmentRulesReOrderTemp, setAssignmentRulesReOrderTemp } = props

  const dispatch = useAppDispatch()
  const [coverageBlockLabels, setCoverageBlockLabels] = useState<
    string[] | null
  >(null)

  const handleDragEnd = useCallback(
    async (result: DropResult) => {
      if (assignmentRulesReOrderTemp.length > 1) {
        const dropped = assignmentRulesReOrderTemp[result.sourceIndex]
        const newRules = [...assignmentRulesReOrderTemp]

        newRules.splice(result.sourceIndex, 1)
        newRules.splice(result.destinationIndex, 0, dropped)
        const finalRules = newRules.map((x, index) => {
          return { ...x, order: index + 1 }
        })
        setAssignmentRulesReOrderTemp(finalRules)

        dispatch(setAssignmentRulesOrder(finalRules))
        const input = finalRules.map((b) => b.id)
        const response = await dispatch(reorderAssignmentRules(input))
        if (reorderAssignmentRules.fulfilled.match(response)) {
          console.log('Succerss LAReorder')
        }
      }
    },
    [dispatch, assignmentRulesReOrderTemp, setAssignmentRulesReOrderTemp],
  )

  const onBulkEnable = useCallback(
    async (isEnable: boolean) => {
      const result = await dispatch(bulkEnableDisable(isEnable))

      if (bulkEnableDisable.rejected.match(result)) {
        const labels = parseCoverageError(result.payload)
        if (labels) {
          setCoverageBlockLabels(labels)
        } else {
          toast.error('Unexpected error occurred.')
        }
      }
    },
    [dispatch],
  )

  const closeCoverageBlock = useCallback(() => {
    setCoverageBlockLabels(null)
  }, [])

  return {
    handleDragEnd,
    onBulkEnable,
    coverageBlockLabels,
    closeCoverageBlock,
  }
}
